import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper'
import './swiper.css'
import './swiper-element.css'

export default function ShopInform({
    rectOptions,
    props,
    zIndex,
}) {
    let { width, height, left, top } = rectOptions
    let { textList, fontSize, fontWeight, color, interval } = props

    return <div
        style={{
            width,
            height,
            left,
            top,
            position: 'absolute',
            zIndex,
        }}
    >
        <div
            style={{
                width: '100%',
                height: '100%',
            }}
            scrollX
        >
            <Swiper
                modules={[Autoplay]}
                loop
                autoplay={{
                    delay: interval * 1000,
                    disableOnInteraction: false
                }}
                style={{
                    width: '100%',
                    height: '100%',
                }}
                direction="vertical"
            >
                {
                    textList.map(({ content }, index) => {
                        return <SwiperSlide key={index}>
                            <div
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    backgroundColor: 'yellow',
                                    fontSize,
                                    fontWeight,
                                    color,
                                }}
                            >
                                {content}
                            </div>
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </div>

    </div>
}